import { render } from "./w-dialog.vue?vue&type=template&id=37413ae8"
import script from "./w-dialog.vue?vue&type=script&lang=js"
export * from "./w-dialog.vue?vue&type=script&lang=js"

import "./w-dialog.vue?vue&type=style&index=0&id=37413ae8&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__